module.exports = __webpack_public_path__ + "media/SWV-I_Gruppendiagnose_2_Fehlende_Bündelung.c1df2808.mp3";